export const GuestLogContent = {
  // Page title
  pageTitle: 'Guest Log',

  // Entry point card
  card: {
    countLabel: 'Guests Visiting Today',
    viewLogCta: 'View Guest Log',
    ariaLabel: 'View guest log',
  },

  // Empty states
  emptyStates: {
    noGuests: 'No guests have been logged yet.',
    noGuestsInRange: 'No guests found for the selected date range.',
  },

  // Drawer labels
  drawer: {
    title: 'Guest Details',
    addedBy: 'Added by',
    guestInfo: 'Guest Info',
    reasonForVisit: 'Reason for Visit',
    timeOfVisit: 'Time of Visit',
    email: 'Email',
  },

  // Export button
  export: {
    label: 'Export Guest Log',
    ariaLabel: 'Export guest log to CSV',
  },

  // Export dialog
  exportDialog: {
    title: 'Export Guest Log',
    description: 'Select a date range to export guest visit records.',
    presetsLabel: 'Quick Presets',
    customLabel: 'Custom Date Range',
    customFrom: 'From',
    customTo: 'To',
    cancel: 'Cancel',
    export: 'Export CSV',
    presets: {
      today: 'Today',
      thisWeek: 'This Week',
      thisMonth: 'This Month',
      thisQuarter: 'This Quarter',
      thisYear: 'This Year',
      allTime: 'All Time',
    },
  },

  // Date filter
  dateFilter: {
    label: 'Date Range',
    allTime: 'All Visits',
    lastDay: 'Visits Today',
    lastWeek: 'Visits This Week',
    lastMonth: 'Visits This Month',
    lastSixMonths: 'Visits (Last 6 Months)',
    custom: 'Custom Range',
  },

  // Pagination
  pagination: {
    loadMore: 'Load More',
    noMore: 'No more guests to load',
  },
};

